// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./i18n";

import HomePage from "./HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ProjectsPage from "./pages/ProjectsPage";
import AskQuestionPage from "./pages/AskQuestionPage";
import BuildProjectPage from "./pages/BuildProjectPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/ask-question" element={<AskQuestionPage />} />
        <Route path="/build-project" element={<BuildProjectPage />} />
        <Route path="/order-tracking" element={<OrderTrackingPage />} />
      </Routes>
    </Router>
  );
}

export default App;